'use client';
import { IMovie } from '@/interfaces/movie';
import { formatCheckValue } from '@/utils/app-utils';
import React, { use, useEffect, useState } from 'react';
import { FaServer } from 'react-icons/fa';

interface Item {
  name: string;
  slug: string;
  embed: string;
  m3u8: string;
}
interface IProps {
  listEpisode: {
    server_name: string;
    items: Item[];
  }[];
  searchParams: {
    tap?: string;
    maychu?: string;
  };
  movie: IMovie;
}

function PlayMovie(props: IProps) {
  const { listEpisode, searchParams, movie } = props;
  const [link, setLink] = useState<Item>();
  const [isDirectLink, setIsDirectLink] = useState<boolean>(true);
  useEffect(() => {
    const currentLink: any = listEpisode.find((val) => {
      return val.server_name === formatCheckValue(searchParams.maychu ?? 'vietsub');
    });
    const data = currentLink.items.find((val: Item) => val.name === searchParams.tap);
    setLink(data);
  }, []);

  const handleClick = () => {
    if (isDirectLink) {
      setIsDirectLink(false);
      window.open(
        'https://www.profitableratecpm.com/jq5yf4utj7?key=aa3848ff8ca415aeec065877a1e5d169',
        '_blank',
      );
    }
  };

  return (
    <div className="mt-3 relative">
      <iframe
        src={link?.embed}
        className="w-full h-[600px] max-lg:h-96 max-md:h-56"
        frameBorder="0"
        allowFullScreen
      ></iframe>
      {isDirectLink && (
        <div
          onClick={handleClick}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 10,
            cursor: 'pointer',
          }}
        ></div>
      )}

      <div className="bg-colorMainOver px-4 py-4 my-3">
        {listEpisode.map((val) => {
          return (
            <div key={val.server_name} className="mb-4 w-full">
              <div className="flex items-center gap-x-2 text-slate-400 font-medium text-[14px]">
                <FaServer color="#5c5e60" size={16} /> {val.server_name}
              </div>
              <div className="flex items-center gap-2 mt-1 w-full flex-wrap">
                {val.items.map((item, index) => {
                  return (
                    <a
                      key={item.m3u8}
                      href={`/phim/${movie.slug}?tap=${item.name}&maychu=${formatCheckValue(val.server_name)}`}
                      className={`flex items-center justify-center max-md:text-[11px] max-md:size-7 size-8 ${searchParams.tap === item.name && val.server_name === formatCheckValue(searchParams.maychu ?? 'vietsub') ? 'bg-yellowMain' : 'bg-redMain'} text-white font-medium rounded text-[14px]`}
                    >
                      {index < 9 && item.name !== 'FULL' ? 0 : null}
                      {item.name}
                    </a>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default PlayMovie;
